import { api } from './api'
import { endpoints } from './endpoints'
import type {
  CreateInternalTransferPayload,
  CreateInternalTransferDTO,
  CreatePurchaseOnRampPayload,
  CreatePurchaseOnRampDTO,
} from '@/types/transfer'

// Request mutation types
interface MutationRequestParams {
  requestId: string
}

export const createInternalTransfer = async (
  payload: CreateInternalTransferPayload,
): Promise<CreateInternalTransferDTO> => {
  const response = await api.post(endpoints.transfer.internal, payload)
  return response.data
}

export const createPurchaseOnRamp = async (
  payload: CreatePurchaseOnRampPayload,
): Promise<CreatePurchaseOnRampDTO> => {
  const response = await api.post(endpoints.transfer.onRamp, {
    user_id: payload.userId,
    amount: payload.amount,
    fiat_currency: payload.fiatCurrency,
    crypto_currency: payload.cryptoCurrency,
    payment_method: payload.paymentMethod,
    // Optional fields (only for send-request flow)
    ...(payload.recipientUserId && {
      recipient_user_id: payload.recipientUserId,
    }),
    ...(payload.phoneNumber && { phone_number: payload.phoneNumber }),
    ...(payload.purpose && { purpose: payload.purpose }),
    ...(payload.paymentRequestId && {
      payment_request_id: payload.paymentRequestId,
    }),
    ...(payload.redirectUrl && { redirect_url: payload.redirectUrl }),
  })
  return response.data
}

// Request management functions
export const declineRequest = async ({
  requestId,
}: MutationRequestParams): Promise<void> => {
  const response = await api.post(endpoints.transfer.declineRequest(requestId))
  return response.data
}

export const cancelRequest = async ({
  requestId,
}: MutationRequestParams): Promise<void> => {
  const response = await api.post(endpoints.transfer.cancelRequest(requestId))
  return response.data
}
